import { Guid } from "@/Common/Models/Guid";
import { FlowsheetClient } from "../Api/FlowsheetClient";
import findFlowsheetSummariesResponseToFlowsheetSummaries from "../Mappers/FindFlowsheetSummariesResponseToFlowsheetSummaries";
import { FlowsheetSummary } from "../Models/FlowsheetSummary";
import { IUseQueryResponse, useQuery } from "./useQuery";

function useFlowsheetSummaries(params: { encounterId?: Guid, patientId?: Guid }): IUseQueryResponse<FlowsheetSummary[]> {
    const queryKey = ["flowsheets"];

    if (params.encounterId != null)
        queryKey.push("byEncounterId", params.encounterId);

    if (params.patientId != null)
        queryKey.push("byPatientId", params.patientId);

    return useQuery({
        query: async () => {
            const response = await FlowsheetClient.findFlowsheetSummaries(params);

            return findFlowsheetSummariesResponseToFlowsheetSummaries(response);
        },
        queryKey
    });
}

export {
    useFlowsheetSummaries
};
